import API from '@/api'
import defaultSetting from '@/settings'
import { changeFavicon } from '@/utils'
const state = {
  showType: 'pc',
  currentRouterKey: 'Index',
  appConfig: {
    description: '',
    gongan_beian: '',
    ico: '',
    icp_beian: '',
    keywords: '',
    logo: '',
    remark: '',
    site: '',
    title: '',
    webstate: ''
  }
}

const mutations = {
  CHANGE_CURRENT_ROUTER_KEY: (state, key) => {
    state.currentRouterKey = key
  },
  SET_APP_CONFIG: (state, data) => {
    state.appConfig = data
    defaultSetting.title = data.title
    defaultSetting.side = data.site
  },
  CHANGE_SHOW_TYPE(state, type) {
    state.showType = type
  }
}

const actions = {
  getSysteamSetting({ commit }) {
    API.SysteamSetting().then(res => {
      if (+res.code === 200) {
        commit('SET_APP_CONFIG', res.data)
        // 设置 浏览器图标
        changeFavicon(res.data.ico || '')
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
